module.exports = {
  APPLICANT_JOINING_FORM: {
    key: "APPLICANT_JOINING_FORM",
    desc: "Provide the joining form for the applicants that needs to be filled",
    default: ["1"],
    type: "integer",
    options: ["1", "2", "3"],
    isSingleValue: true,
    is_active: false,
  },
  MAILING_FACILITY_PROCESS: {
    key: "MAILING_FACILITY_PROCESS",
    desc: "On true the mailing feature will be enabled throughout the website",
    default: ["false"],
    type: "boolean",
    options: ["true", "false"],
    isSingleValue: true,
    is_active: false,
  },
  DEVS_MAILING_LIST: {
    key: "DEVS_MAILING_LIST",
    desc: `Provide the list of email id's to be used as recipient for mailing facility`,
    default: [],
    type: "string",
    options: [],
    isSingleValue: false,
    is_active: false,
  },
  REVIEWERS_COUNT: {
    key: "REVIEWERS_COUNT",
    desc: "Provide the count of reviews needed to make a decision over the candidate",
    default: ["1"],
    type: "integer",
    options: ["1", "2", "3"],
    isSingleValue: true,
    is_active: false,
  },
  PENDING_MAILS_COUNT: {
    key: "PENDING_MAILS_COUNT",
    desc: "Provide the count of pending mails to be sent at once. This is used in the cron job.",
    default: ["1"],
    type: "integer",
    is_active: false,
  },
  PUBLISH_PENDING_EVENTS_COUNT: {
    key: "PUBLISH_PENDING_EVENTS_COUNT",
    desc: "Provide the count of pending events to publish at once. This is used in the cron job.",
    default: ["0"],
    type: "integer",
    is_active: false,
  },
  MAIL_SENDER: {
    key: "MAIL_SENDER",
    desc: "The mails will be sent using the selected mail.",
    default: ["PRIMARY - hr@argusoft.com"],
    options: [
      "PRIMARY - hr@argusoft.com",
      "SECONDARY - hr.argusoft@argusoft.com",
    ],
    type: "string",
    isSingleValue: true,
    is_active: false,
  },
  FRESHER_OPENING: {
    key: "FRESHER_OPENING",
    desc: "At true, positions with freshers as requirement will be visible to everyone visiting the website",
    default: ["false"],
    type: "boolean",
    options: ["true", "false"],
    isSingleValue: true,
    is_active: false,
  },
  PROFESSIONAL_OPENING: {
    key: "PROFESSIONAL_OPENING",
    desc: "At true, positions which allows experienced professional as candidate will be visible to everyone",
    default: ["false"],
    type: "boolean",
    options: ["true", "false"],
    isSingleValue: true,
    is_active: false,
  },
  SKILL_SET: {
    key: "SKILL_SET",
    desc: "This list acts as an pre-options for candidates to select their skillset",
    default: [],
    type: "string",
    options: [
      "JavaScript",
      "Python",
      "Java",
      "C#",
      "C++",
      "Go",
      "React.js",
      "Angular",
      "Vue.js",
      "Node.js",
      "AWS",
      "Azure",
      "GCP",
      "serverless computing",
      "MySQL",
      "PostgreSQL",
      "MongoDB",
      "Redis",
    ],
    isSingleValue: false,
    is_active: false,
  },

  FORMS: {
    isChild: true,
    key: "FORMS",
    desc: "Provide the folder id to store uploaded files from interviewer and reviewer remarks",
    default: ["1HXgD1cPOpwAQaG0tMuUH6Edus7VfbeJ4"],
    type: "string",
    isSingleValue: true,
    isInput: true,
    is_active: true,
  },
  APPLICATION_PROFILE_PIC: {
    isChild: true,
    key: "APPLICATION_PROFILE_PIC",
    desc: "Provide the folder id to store profile pictures from applications",
    default: ["1e8GiAap_6a5vNvJYht5SUg_kLBr73AKD"],
    type: "string",
    isSingleValue: true,
    isInput: true,
    is_active: true,
  },
  APPLICATION_RESUME: {
    isChild: true,
    key: "APPLICATION_RESUME",
    desc: "Provide the folder id to store resumes from applications",
    default: ["175I6wywwfhDNJF0v6nhL01SXUC0kvpKG"],
    type: "string",
    isSingleValue: true,
    isInput: true,
    is_active: true,
  },
  APPLICANT_MASTER_PROFILE_PIC: {
    isChild: true,
    key: "APPLICANT_MASTER_PROFILE_PIC",
    desc: "Provide the folder id to store profile pictures from applicant profiles",
    default: ["1ly4IjxaY3fa-RBOGqfXmy3fiB5X790Dd"],
    type: "string",
    isSingleValue: true,
    isInput: true,
    is_active: true,
  },
  APPLICANT_MASTER_RESUME: {
    isChild: true,
    key: "APPLICANT_MASTER_RESUME",
    desc: "Provide the folder id to store resumes from applicant profiles",
    default: ["1o5miSyACUg4K-tOAl87bu6O6KPeHPN0V"],
    type: "string",
    isSingleValue: true,
    isInput: true,
    is_active: true,
  },
  APPLICANT_MASTER_10TH_MARKSHEET: {
    isChild: true,
    key: "APPLICANT_MASTER_10TH_MARKSHEET",
    desc: "Provide the folder id to store 10th marksheets from applicant profiles",
    default: ["1QqdLuydWCfMtmzZ89OKl4kq6FSOrCX3E"],
    type: "string",
    isSingleValue: true,
    isInput: true,
    is_active: true,
  },
  APPLICANT_MASTER_12TH_MARKSHEET: {
    isChild: true,
    key: "APPLICANT_MASTER_12TH_MARKSHEET",
    desc: "Provide the folder id to store 12th marksheets from applicant profiles",
    default: ["1VO_jWlBv5NEw2EeT7CmisOkTZQ32d4qs"],
    type: "string",
    isSingleValue: true,
    isInput: true,
    is_active: true,
  },
  APPLICANT_MASTER_AADHAR: {
    isChild: true,
    key: "APPLICANT_MASTER_AADHAR",
    desc: "Provide the folder id to store resumes from applicant profiles",
    default: ["1Ul2ND3aXCDpAJNPM1myyXwxkgxB3-QBO"],
    type: "string",
    isSingleValue: true,
    isInput: true,
    is_active: true,
  },
  APPLICANT_MASTER_PAN_CARD: {
    isChild: true,
    key: "APPLICANT_MASTER_PAN_CARD",
    desc: "Provide the folder id to store resumes from applicant profiles",
    default: ["1BwztN7_mBmIEOA2Ulug-cyjp6w_bX6cz"],
    type: "string",
    isSingleValue: true,
    isInput: true,
    is_active: true,
  },
  APPLICANT_MASTER_EXPERIENCE_LETTER: {
    isChild: true,
    key: "APPLICANT_MASTER_EXPERIENCE_LETTER",
    desc: "Provide the folder id to store resumes from applicant profiles",
    default: ["1B6-TIgPmz2PSb2xe_l8aVelN3DLe_fGn"],
    type: "string",
    isSingleValue: true,
    isInput: true,
    is_active: true,
  },
  APPLICANT_MASTER_RELIEVING_LETTER: {
    isChild: true,
    key: "APPLICANT_MASTER_RELIEVING_LETTER",
    desc: "Provide the folder id to store resumes from applicant profiles",
    default: ["1z5TAF3iq8TFp0K2VOdpDWyJwPwKXSK0d"],
    type: "string",
    isSingleValue: true,
    isInput: true,
    is_active: true,
  },
  APPLICANT_MASTER_SALARY_SLIP: {
    isChild: true,
    key: "APPLICANT_MASTER_SALARY_SLIP",
    desc: "Provide the folder id to store resumes from applicant profiles",
    default: ["1bbv03H3bDbTYPyNHuEUftN-NsHwkiHEA"],
    type: "string",
    isSingleValue: true,
    isInput: true,
    is_active: true,
  },
  APPLICANT_MASTER_GRADUATE_DEGREE_CERTIFICATE: {
    isChild: true,
    key: "APPLICANT_MASTER_GRADUATE_DEGREE_CERTIFICATE",
    desc: "Provide the folder id to store resumes from applicant profiles",
    default: ["1EKGVbXRyEoxncUrakXGouGKe7SUzE65t"],
    type: "string",
    isSingleValue: true,
    isInput: true,
    is_active: true,
  },
  APPLICANT_MASTER_POST_GRADUATE_DEGREE: {
    isChild: true,
    key: "APPLICANT_MASTER_POST_GRADUATE_DEGREE",
    desc: "Provide the folder id to store resumes from applicant profiles",
    default: ["1bilP6FxcH3Dr1TfPhtIhFLt6SDSMwBWr"],
    type: "string",
    isSingleValue: true,
    isInput: true,
    is_active: true,
  },
  FILE_TEMPLATE_MASTER: {
    isChild: true,
    key: "FILE_TEMPLATE_MASTER",
    desc: "Provide the folder id to store file templates",
    default: ["1o5miSyACUg4K-tOAl87bu6O6KPeHPN0V"], //currently using resume folder id
    type: "string",
    isSingleValue: true,
    isInput: true,
    is_active: true,
  },
};
